import { ChannelUtil } from '@commons/util/helper/channel';
import { isUndefined } from 'angular';

import {
  Channel as IChannel,
  ChannelDirection,
  ChannelSubType,
  ChannelType,
  MixableChannel,
  None,
  OpeningChannel,
  Option,
} from '@contact/upgrade';

export interface ITypedChannel {
  type: ChannelType;
  direction: ChannelDirection;
  name?: string;
  planning?: string[];
  subType?: ChannelSubType;
  enabled?: boolean;
  active?: boolean;
}

/**
 * @deprecated, prefer ChannelUtil
 */
export class ChannelDeprecatedImpl {
  static INCOMING_PHONE: IChannel = ChannelUtil.INCOMING_PHONE;
  static OUTGOING_PHONE: IChannel = ChannelUtil.OUTGOING_PHONE;
  static OUTGOING_UNITARY_PHONE: IChannel = ChannelUtil.OUTGOING_UNITARY_PHONE;
  static INCOMING_CHAT: IChannel = ChannelUtil.INCOMING_CHAT;
  static INCOMING_CHATBOT: IChannel = ChannelUtil.INCOMING_CHATBOT;
  static INCOMING_CHAT_IADVIZE: IChannel = ChannelUtil.INCOMING_CHAT_IADVIZE;
  static INCOMING_BASKET: IChannel = ChannelUtil.INCOMING_BASKET;
  static INCOMING_SOCIAL_NETWORK: IChannel = ChannelUtil.INCOMING_SOCIAL_NETWORK;
  static INCOMING_MAIL: IChannel = ChannelUtil.INCOMING_MAIL;
  static OUTGOING_MAIL: IChannel = ChannelUtil.OUTGOING_MAIL;
  static OUTGOING_VISIO: IChannel = ChannelUtil.OUTGOING_VISIO;

  static toString(channel: IChannel): string {
    return ChannelUtil.toString(channel);
  }

  static areSame(chanOne: IChannel, chanTwo: IChannel): boolean {
    return ChannelUtil.areSame(chanOne, chanTwo);
  }

  static from(channelStr: string): Option<IChannel> {
    return Option.of(ChannelUtil.from(channelStr));
  }

  static subTypeFrom(channelSubTypeStr: string): Option<ChannelSubType> {
    let result: ChannelSubType = ChannelSubType[channelSubTypeStr];
    if (!isUndefined(result)) {
      return Option.of(result);
    }
    return None;
  }

  static comparePriorities(chanTypeOne: ChannelType, chanTypeTwo: ChannelType): number {
    return ChannelUtil.comparePriorities(chanTypeOne, chanTypeTwo);
  }

  static compareOrder(c1: IChannel, c2: IChannel): number {
    return ChannelUtil.compareOrder(c1, c2);
  }

  static compareDirectionOrder(d1: ChannelDirection, d2: ChannelDirection): number {
    return ChannelUtil.compareDirectionOrder(d1, d2);
  }

  static isMixableWith(channelMixable: MixableChannel, expectedChannel: IChannel): boolean {
    return ChannelUtil.isMixableWith(channelMixable, expectedChannel);
  }

  static isOpeningWith(channelOpening: OpeningChannel, expectedChannel: IChannel): boolean {
    return ChannelUtil.isOpeningWith(channelOpening, expectedChannel);
  }
}
